import { payPeriodService, queryClientOptions } from '@libs/data-access/queries'
import type { PayPeriodModel } from '@spa/scenes/Plannings/redux/models/PayPeriod'
import { computeLockedDays } from '@spa/scenes/Plannings/redux/selectors/entities/payPeriods/utils/computeLockedDays'
import { isEqual } from 'lodash-es'
import { useEffect, useState } from 'react'

export const useGetLockedDays = (isoDays: string[]) => {
  const [lockedDays, setLockedDays] = useState<{
    [x: string]: {
      isLocked: boolean
    }
  }>({})

  const { data } = payPeriodService.payPeriod.useFetchAll(
    {},
    {
      staleTime: queryClientOptions.time.STATIC
    }
  )
  useEffect(() => {
    if (data) {
      const newLockedDays = computeLockedDays(
        data.pay_periods as unknown[] as PayPeriodModel[],
        isoDays
      )
      if (!isEqual(newLockedDays, lockedDays)) {
        setLockedDays(newLockedDays)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isoDays])

  return {
    lockedDays
  }
}
